"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoClient = useVideoClient;
var vue_1 = require("vue");
var VideoClientFactory_1 = require("../factories/VideoClientFactory");
/**
 * Use Video Client Composable
 * Provider-agnostic composable for video calls
 *
 * Supports multiple providers:
 * - vanilla-webrtc: Uses WebRTC with WebSocket signaling
 * - zoom: Uses Zoom Video SDK with JWT tokens
 * - chime: Uses AWS Chime SDK (future)
 *
 * @param sessionId - Session identifier
 * @param userId - User identifier
 * @param role - User role ('nurse' or 'patient')
 * @param providerType - Provider type (from API response or environment)
 * @param credentials - Authentication credentials (e.g., Zoom JWT token)
 * @param signalingService - Signaling service (required for vanilla WebRTC only)
 */
function useVideoClient(sessionId, userId, _role, providerType, credentials, signalingService) {
    var _this = this;
    var localStream = (0, vue_1.ref)(null);
    var remoteStream = (0, vue_1.ref)(null);
    var isConnected = (0, vue_1.ref)(false);
    var error = (0, vue_1.ref)(null);
    var videoClient = (0, vue_1.ref)(null);
    // For vanilla WebRTC only
    var peerConnection = (0, vue_1.ref)(null);
    // Closed-captioning state
    var captionsEnabled = (0, vue_1.ref)(false);
    var currentCaption = (0, vue_1.ref)('');
    var captionHistory = (0, vue_1.ref)([]);
    /**
     * Initialize video client
     */
    var initializeClient = function () { return __awaiter(_this, void 0, void 0, function () {
        var requireEnv, apiUrl, socketUrl, stunServer, hasWebpackVars, viteEnv, appConfig, config, _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    console.log('[useVideoClient] Initializing client', { providerType: providerType });
                    return [4 /*yield*/, Promise.resolve().then(function () { return require('../utils/env'); })];
                case 1:
                    requireEnv = (_b.sent()).requireEnv;
                    apiUrl = '';
                    socketUrl = '';
                    stunServer = 'stun:stun.l.google.com:19302';
                    hasWebpackVars = false;
                    try {
                        // @ts-ignore - webpack replaces process.env.X at build time
                        if (process.env.VUE_APP_API_BASE_URL) {
                            // @ts-ignore
                            apiUrl = requireEnv(process.env.VUE_APP_API_BASE_URL, 'VUE_APP_API_BASE_URL');
                            // @ts-ignore
                            socketUrl = requireEnv(process.env.VUE_APP_SOCKET_URL, 'VUE_APP_SOCKET_URL');
                            hasWebpackVars = true;
                        }
                    }
                    catch (e) {
                        // process not defined or env vars not set
                    }
                    // Try Vite vars if Webpack vars not found
                    if (!hasWebpackVars) {
                        if (typeof import.meta !== 'undefined' && import.meta.env) {
                            viteEnv = import.meta.env;
                            if (viteEnv.VITE_API_BASE_URL) {
                                apiUrl = requireEnv(viteEnv.VITE_API_BASE_URL, 'VITE_API_BASE_URL');
                                socketUrl = requireEnv(viteEnv.VITE_SOCKET_URL, 'VITE_SOCKET_URL');
                            }
                            else {
                                throw new Error('Missing required Vite environment variables: VITE_API_BASE_URL, VITE_SOCKET_URL');
                            }
                        }
                        else {
                            throw new Error('Unable to detect build system: No environment variables found');
                        }
                    }
                    appConfig = {
                        apiUrl: apiUrl,
                        socketUrl: socketUrl,
                        stunServer: stunServer,
                    };
                    console.log('[useVideoClient] Using resolved config', appConfig);
                    config = {
                        apiUrl: appConfig.apiUrl,
                        socketUrl: appConfig.socketUrl,
                        stunServers: [appConfig.stunServer].filter(Boolean),
                    };
                    // Create appropriate client based on provider (now async due to lazy loading)
                    console.log('[useVideoClient] Creating video client...');
                    _a = videoClient;
                    return [4 /*yield*/, VideoClientFactory_1.VideoClientFactory.createClient(providerType, config)];
                case 2:
                    _a.value = _b.sent();
                    console.log('[useVideoClient] Video client created');
                    console.log('[useVideoClient] Initializing video client...');
                    return [4 /*yield*/, videoClient.value.initialize(config)];
                case 3:
                    _b.sent();
                    console.log('[useVideoClient] Video client initialized');
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _b.sent();
                    console.error('[useVideoClient] Failed to initialize client:', err_1);
                    throw err_1;
                case 5:
                    // Set up event listeners
                    videoClient.value.on('connected', function () {
                        console.log('[useVideoClient] Connected');
                        isConnected.value = true;
                    });
                    videoClient.value.on('disconnected', function () {
                        console.log('[useVideoClient] Disconnected');
                        isConnected.value = false;
                    });
                    videoClient.value.on('remote-stream-added', function (stream) {
                        console.log('[useVideoClient] Remote stream added!', {
                            streamId: stream.id,
                            tracks: stream.getTracks().map(function (t) { return ({ kind: t.kind, id: t.id, enabled: t.enabled }); })
                        });
                        remoteStream.value = stream;
                        console.log('[useVideoClient] Remote stream set in composable');
                    });
                    videoClient.value.on('error', function (err) {
                        console.error('[useVideoClient] Error:', err);
                        error.value = err.message;
                    });
                    // Handle media diagnostics event (from ZoomClient or other providers)
                    console.log('[useVideoClient] Registering media_diagnostics event listener');
                    videoClient.value.on('media_diagnostics', function (diagnostics) {
                        console.log('[useVideoClient] media_diagnostics event RECEIVED from video client');
                        console.log('[useVideoClient] Diagnostics data:', JSON.stringify(diagnostics, null, 2));
                        // Forward to backend via signaling service (if available)
                        if (signalingService) {
                            // Check if it has emitToBackend (new method) or fall back to emit
                            if (typeof signalingService.emitToBackend === 'function') {
                                console.log('[useVideoClient] Sending media diagnostics to backend via WebSocket (emitToBackend)');
                                signalingService.emitToBackend('media_diagnostics', diagnostics);
                                console.log('[useVideoClient] media_diagnostics sent to backend successfully');
                            }
                            else if (typeof signalingService.emit === 'function') {
                                console.log('[useVideoClient] Sending media diagnostics to backend via WebSocket (emit)');
                                signalingService.emit('media_diagnostics', diagnostics);
                                console.log('[useVideoClient] media_diagnostics sent to backend successfully');
                            }
                            else {
                                console.warn('[useVideoClient] Signaling service does not have emit method');
                            }
                        }
                        else {
                            console.warn('[useVideoClient] Signaling service not available - cannot send diagnostics to backend');
                        }
                    });
                    // Set up caption event listeners
                    videoClient.value.on('caption-received', function (captionData) {
                        console.log('[useVideoClient] Caption received:', captionData);
                        currentCaption.value = captionData.text;
                        // Add to history if it's a final caption
                        if (captionData.isFinal) {
                            captionHistory.value.push({
                                text: captionData.text,
                                timestamp: captionData.timestamp,
                                speakerId: captionData.speakerId,
                            });
                            // Keep only last 50 captions to prevent memory leak
                            if (captionHistory.value.length > 50) {
                                captionHistory.value.shift();
                            }
                        }
                    });
                    videoClient.value.on('caption-enabled', function () {
                        console.log('[useVideoClient] Captions enabled');
                        captionsEnabled.value = true;
                    });
                    videoClient.value.on('caption-disabled', function () {
                        console.log('[useVideoClient] Captions disabled');
                        captionsEnabled.value = false;
                        currentCaption.value = '';
                    });
                    console.log('[useVideoClient] Client initialized', { provider: providerType });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Merge Pinia/API credentials with an optional per-call override (e.g. join API
     * fetched in ActiveCallView when the route loads without prior confirmCall).
     */
    var resolveZoomJoinCredentials = function (override) {
        var merged = __assign(__assign({}, credentials), override);
        var token = merged.token;
        if (typeof token !== 'string' || token.trim().length === 0) {
            throw new Error('Zoom session token is missing. Join the session via the API or complete the call flow first.');
        }
        var name = typeof merged.userName === 'string' && merged.userName.trim().length > 0
            ? merged.userName.trim()
            : userId;
        return __assign(__assign({}, merged), { token: token.trim(), userName: name });
    };
    /**
     * Start call (for initiator/nurse)
     * @param credentialsOverride - Optional credentials when store was empty at composable setup
     */
    var startCall = function (credentialsOverride) { return __awaiter(_this, void 0, void 0, function () {
        var joinCreds, _a, mediaErr_1, _b, err_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 13, , 14]);
                    error.value = null;
                    if (!!videoClient.value) return [3 /*break*/, 2];
                    return [4 /*yield*/, initializeClient()];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!(providerType === 'zoom')) return [3 /*break*/, 9];
                    joinCreds = resolveZoomJoinCredentials(credentialsOverride);
                    return [4 /*yield*/, videoClient.value.joinSession(sessionId, joinCreds)];
                case 3:
                    _c.sent();
                    console.log('[useVideoClient] Joined Zoom session');
                    // CRITICAL: Wait for SDK internal initialization to complete
                    // The error "shouldUseWebRTC undefined" occurs during SDK's async
                    // post-join setup. Give it time to stabilize before media operations.
                    console.log('[useVideoClient] Waiting 2s for SDK stabilization...');
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2000); })];
                case 4:
                    _c.sent();
                    console.log('[useVideoClient] SDK stabilization wait complete');
                    _c.label = 5;
                case 5:
                    _c.trys.push([5, 7, , 8]);
                    _a = localStream;
                    return [4 /*yield*/, videoClient.value.getLocalMedia({
                            video: {
                                facingMode: 'user',
                                width: { ideal: 1280 },
                                height: { ideal: 720 },
                            },
                            audio: {
                                echoCancellation: true,
                                noiseSuppression: true,
                            },
                        })];
                case 6:
                    _a.value = _c.sent();
                    console.log('[useVideoClient] Local media obtained');
                    return [3 /*break*/, 8];
                case 7:
                    mediaErr_1 = _c.sent();
                    console.warn('[useVideoClient] Failed to get local media - proceeding without local camera:', mediaErr_1);
                    console.warn('[useVideoClient] Call will work in receive-only mode');
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 12];
                case 9:
                    // For vanilla WebRTC: Get media first, then use WebSocket signaling
                    _b = localStream;
                    return [4 /*yield*/, videoClient.value.getLocalMedia({
                            video: {
                                facingMode: 'user',
                                width: { ideal: 1280 },
                                height: { ideal: 720 },
                            },
                            audio: {
                                echoCancellation: true,
                                noiseSuppression: true,
                            },
                        })];
                case 10:
                    // For vanilla WebRTC: Get media first, then use WebSocket signaling
                    _b.value = _c.sent();
                    return [4 /*yield*/, startVanillaWebRTCCall()];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12: return [3 /*break*/, 14];
                case 13:
                    err_2 = _c.sent();
                    console.error('[useVideoClient] Error starting call:', err_2);
                    error.value = err_2 instanceof Error ? err_2.message : 'Failed to start call';
                    throw err_2;
                case 14: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Answer call (for answerer/patient)
     * @param credentialsOverride - Optional credentials when store was empty at composable setup
     */
    var answerCall = function (credentialsOverride) { return __awaiter(_this, void 0, void 0, function () {
        var joinCreds, _a, mediaErr_2, err_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 11, , 12]);
                    error.value = null;
                    if (!!videoClient.value) return [3 /*break*/, 2];
                    return [4 /*yield*/, initializeClient()];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(providerType === 'zoom')) return [3 /*break*/, 8];
                    joinCreds = resolveZoomJoinCredentials(credentialsOverride);
                    return [4 /*yield*/, videoClient.value.joinSession(sessionId, joinCreds)
                        // Get local media for Zoom
                        // NOTE: Local camera may fail on some devices/browsers due to WebRTC capability limitations.
                        // This is non-fatal - the call can proceed with remote video only.
                    ];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    _a = localStream;
                    return [4 /*yield*/, videoClient.value.getLocalMedia({
                            video: {
                                facingMode: 'user',
                                width: { ideal: 1280 },
                                height: { ideal: 720 },
                            },
                            audio: {
                                echoCancellation: true,
                                noiseSuppression: true,
                            },
                        })];
                case 5:
                    _a.value = _b.sent();
                    console.log('[useVideoClient] Local media obtained');
                    return [3 /*break*/, 7];
                case 6:
                    mediaErr_2 = _b.sent();
                    console.warn('[useVideoClient] Failed to get local media - proceeding without local camera:', mediaErr_2);
                    console.warn('[useVideoClient] Call will work in receive-only mode');
                    return [3 /*break*/, 7];
                case 7:
                    console.log('[useVideoClient] Joined Zoom session');
                    return [3 /*break*/, 10];
                case 8: 
                // For vanilla WebRTC: Use WebSocket signaling
                return [4 /*yield*/, answerVanillaWebRTCCall()];
                case 9:
                    // For vanilla WebRTC: Use WebSocket signaling
                    _b.sent();
                    _b.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    err_3 = _b.sent();
                    console.error('[useVideoClient] Error answering call:', err_3);
                    error.value = err_3 instanceof Error ? err_3.message : 'Failed to answer call';
                    throw err_3;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Vanilla WebRTC: Start call with signaling
     */
    var startVanillaWebRTCCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var client, _a, offer, handleAnswer, handleIceCandidate;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!signalingService) {
                        throw new Error('Signaling service required for vanilla WebRTC');
                    }
                    client = videoClient.value;
                    // Initialize peer connection
                    _a = peerConnection;
                    return [4 /*yield*/, client.initializePeerConnection()
                        // Set up ICE candidate handling
                    ];
                case 1:
                    // Initialize peer connection
                    _a.value = _b.sent();
                    // Set up ICE candidate handling
                    peerConnection.value.onicecandidate = function (event) {
                        if (event.candidate) {
                            console.log('[useVideoClient] Sending ICE candidate');
                            signalingService.sendIceCandidate(sessionId, event.candidate.toJSON(), userId);
                        }
                    };
                    // Add local tracks
                    console.log('[useVideoClient] Adding local tracks to peer connection');
                    localStream.value.getTracks().forEach(function (track) {
                        console.log('[useVideoClient] Adding track:', track.kind, track.id);
                        peerConnection.value.addTrack(track, localStream.value);
                    });
                    console.log('[useVideoClient] All tracks added');
                    return [4 /*yield*/, peerConnection.value.createOffer()];
                case 2:
                    offer = _b.sent();
                    return [4 /*yield*/, peerConnection.value.setLocalDescription(offer)];
                case 3:
                    _b.sent();
                    console.log('[useVideoClient] Sending offer');
                    signalingService.sendOffer(sessionId, offer, userId);
                    handleAnswer = function (event) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(event.sessionId === sessionId)) return [3 /*break*/, 2];
                                    console.log('[useVideoClient] Received answer');
                                    return [4 /*yield*/, peerConnection.value.setRemoteDescription(event.answer)];
                                case 1:
                                    _a.sent();
                                    signalingService.off('answer', handleAnswer);
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    signalingService.on('answer', handleAnswer);
                    handleIceCandidate = function (event) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(event.sessionId === sessionId && event.from !== userId)) return [3 /*break*/, 2];
                                    console.log('[useVideoClient] Received ICE candidate');
                                    return [4 /*yield*/, peerConnection.value.addIceCandidate(event.candidate)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    signalingService.on('ice-candidate', handleIceCandidate);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Vanilla WebRTC: Answer call with signaling
     */
    var answerVanillaWebRTCCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var client, _a, mediaReady, handleOffer, handleIceCandidate, _b;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!signalingService) {
                        throw new Error('Signaling service required for vanilla WebRTC');
                    }
                    client = videoClient.value;
                    // Initialize peer connection
                    _a = peerConnection;
                    return [4 /*yield*/, client.initializePeerConnection()
                        // Track if media is ready
                    ];
                case 1:
                    // Initialize peer connection
                    _a.value = _c.sent();
                    mediaReady = false;
                    handleOffer = function (event) { return __awaiter(_this, void 0, void 0, function () {
                        var answer;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(event.sessionId === sessionId)) return [3 /*break*/, 7];
                                    console.log('[useVideoClient] Received offer, waiting for media...');
                                    _a.label = 1;
                                case 1:
                                    if (!!mediaReady) return [3 /*break*/, 3];
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 1];
                                case 3:
                                    console.log('[useVideoClient] Media ready, setting remote description');
                                    return [4 /*yield*/, peerConnection.value.setRemoteDescription(event.offer)
                                        // Create and send answer
                                    ];
                                case 4:
                                    _a.sent();
                                    return [4 /*yield*/, peerConnection.value.createAnswer()];
                                case 5:
                                    answer = _a.sent();
                                    return [4 /*yield*/, peerConnection.value.setLocalDescription(answer)];
                                case 6:
                                    _a.sent();
                                    console.log('[useVideoClient] Sending answer');
                                    signalingService.sendAnswer(sessionId, answer, userId);
                                    signalingService.off('offer', handleOffer);
                                    _a.label = 7;
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); };
                    signalingService.on('offer', handleOffer);
                    // Set up ICE candidate handling
                    peerConnection.value.onicecandidate = function (event) {
                        if (event.candidate) {
                            console.log('[useVideoClient] Sending ICE candidate');
                            signalingService.sendIceCandidate(sessionId, event.candidate.toJSON(), userId);
                        }
                    };
                    handleIceCandidate = function (event) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(event.sessionId === sessionId && event.from !== userId)) return [3 /*break*/, 2];
                                    console.log('[useVideoClient] Received ICE candidate');
                                    return [4 /*yield*/, peerConnection.value.addIceCandidate(event.candidate)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                    signalingService.on('ice-candidate', handleIceCandidate);
                    // Get local media
                    _b = localStream;
                    return [4 /*yield*/, videoClient.value.getLocalMedia({
                            video: {
                                facingMode: 'user',
                                width: { ideal: 1280 },
                                height: { ideal: 720 },
                            },
                            audio: {
                                echoCancellation: true,
                                noiseSuppression: true,
                            },
                        })
                        // Add local tracks
                    ];
                case 2:
                    // Get local media
                    _b.value = _c.sent();
                    // Add local tracks
                    localStream.value.getTracks().forEach(function (track) {
                        console.log('[useVideoClient] Adding track:', track.kind);
                        peerConnection.value.addTrack(track, localStream.value);
                    });
                    mediaReady = true;
                    console.log('[useVideoClient] Patient ready - tracks added');
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * End call and clean up
     */
    var endCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    console.log('[useVideoClient] Ending call');
                    if (!(providerType === 'zoom')) return [3 /*break*/, 10];
                    if (!videoClient.value) return [3 /*break*/, 9];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, videoClient.value.stopVideo()];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, videoClient.value.muteAudio()];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _b = _c.sent();
                    return [3 /*break*/, 7];
                case 7: return [4 /*yield*/, videoClient.value.leaveSession()];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9: return [3 /*break*/, 13];
                case 10:
                    // Vanilla WebRTC — stop raw MediaStream tracks
                    if (localStream.value) {
                        localStream.value.getTracks().forEach(function (track) {
                            console.log("[useVideoClient] Stopping track: ".concat(track.kind, " (").concat(track.id, ")"));
                            track.stop();
                        });
                    }
                    if (remoteStream.value) {
                        remoteStream.value.getTracks().forEach(function (track) { return track.stop(); });
                    }
                    if (!videoClient.value) return [3 /*break*/, 12];
                    return [4 /*yield*/, videoClient.value.leaveSession()];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12:
                    if (peerConnection.value) {
                        peerConnection.value.close();
                        peerConnection.value = null;
                    }
                    _c.label = 13;
                case 13:
                    localStream.value = null;
                    remoteStream.value = null;
                    isConnected.value = false;
                    isAudioMuted.value = false;
                    isVideoStopped.value = false;
                    console.log('[useVideoClient] Call ended');
                    return [2 /*return*/];
            }
        });
    }); };
    // Provider-level mute/video state for Zoom (Zoom streams have no real MediaStream
    // tracks, so track.enabled cannot be used as a state indicator).
    var isAudioMuted = (0, vue_1.ref)(false);
    var isVideoStopped = (0, vue_1.ref)(false);
    /**
     * Toggle audio mute/unmute
     */
    var toggleAudio = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_4, audioTrack;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!videoClient.value)
                        return [2 /*return*/];
                    if (!(providerType === 'zoom')) return [3 /*break*/, 8];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!isAudioMuted.value) return [3 /*break*/, 3];
                    return [4 /*yield*/, videoClient.value.unmuteAudio()];
                case 2:
                    _b.sent();
                    isAudioMuted.value = false;
                    console.log('[useVideoClient] Zoom audio unmuted');
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, videoClient.value.muteAudio()];
                case 4:
                    _b.sent();
                    isAudioMuted.value = true;
                    console.log('[useVideoClient] Zoom audio muted');
                    _b.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_4 = _b.sent();
                    console.error('[useVideoClient] Failed to toggle audio:', err_4);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    audioTrack = (_a = localStream.value) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0];
                    if (audioTrack) {
                        audioTrack.enabled = !audioTrack.enabled;
                    }
                    _b.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Toggle video on/off
     */
    var toggleVideo = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_5, videoTrack;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!videoClient.value)
                        return [2 /*return*/];
                    if (!(providerType === 'zoom')) return [3 /*break*/, 8];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!isVideoStopped.value) return [3 /*break*/, 3];
                    return [4 /*yield*/, videoClient.value.startVideo()];
                case 2:
                    _b.sent();
                    isVideoStopped.value = false;
                    console.log('[useVideoClient] Zoom video started');
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, videoClient.value.stopVideo()];
                case 4:
                    _b.sent();
                    isVideoStopped.value = true;
                    console.log('[useVideoClient] Zoom video stopped');
                    _b.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_5 = _b.sent();
                    console.error('[useVideoClient] Failed to toggle video:', err_5);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    videoTrack = (_a = localStream.value) === null || _a === void 0 ? void 0 : _a.getVideoTracks()[0];
                    if (videoTrack) {
                        videoTrack.enabled = !videoTrack.enabled;
                    }
                    _b.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // ==============================
    // Closed-Captioning Methods
    // ==============================
    /**
     * Check if captions are supported by the current provider
     */
    var supportsCaptions = (0, vue_1.computed)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = videoClient.value) === null || _a === void 0 ? void 0 : _a.supportsClosedCaptions) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : false;
    });
    /**
     * Get available caption languages
     */
    var availableCaptionLanguages = (0, vue_1.computed)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = videoClient.value) === null || _a === void 0 ? void 0 : _a.getAvailableCaptionLanguages) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [];
    });
    /**
     * Enable closed captions
     * @param language - Language code (e.g., 'en-US', 'es-ES')
     */
    var enableCaptions = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (language) {
            var err_6;
            if (language === void 0) { language = 'en-US'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!videoClient.value) {
                            throw new Error('Video client not initialized');
                        }
                        if (!videoClient.value.enableClosedCaptions) {
                            throw new Error('Closed captions not supported by this provider');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, videoClient.value.enableClosedCaptions(language)];
                    case 2:
                        _a.sent();
                        captionsEnabled.value = true;
                        console.log("[useVideoClient] Captions enabled: ".concat(language));
                        return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        console.error('[useVideoClient] Failed to enable captions:', err_6);
                        throw err_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Disable closed captions
     */
    var disableCaptions = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!videoClient.value) {
                        throw new Error('Video client not initialized');
                    }
                    if (!videoClient.value.disableClosedCaptions) {
                        throw new Error('Closed captions not supported by this provider');
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, videoClient.value.disableClosedCaptions()];
                case 2:
                    _a.sent();
                    captionsEnabled.value = false;
                    currentCaption.value = '';
                    console.log('[useVideoClient] Captions disabled');
                    return [3 /*break*/, 4];
                case 3:
                    err_7 = _a.sent();
                    console.error('[useVideoClient] Failed to disable captions:', err_7);
                    throw err_7;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Toggle captions on/off
     * @param language - Language code (default: 'en-US')
     */
    var toggleCaptions = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (language) {
            if (language === void 0) { language = 'en-US'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!captionsEnabled.value) return [3 /*break*/, 2];
                        return [4 /*yield*/, disableCaptions()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, enableCaptions(language)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Cleanup on unmount
     */
    (0, vue_1.onUnmounted)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, endCall()];
                case 1:
                    _a.sent();
                    if (!videoClient.value) return [3 /*break*/, 3];
                    return [4 /*yield*/, videoClient.value.dispose()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); });
    return {
        localStream: localStream,
        remoteStream: remoteStream,
        isConnected: isConnected,
        error: error,
        startCall: startCall,
        answerCall: answerCall,
        endCall: endCall,
        toggleAudio: toggleAudio,
        toggleVideo: toggleVideo,
        // Caption controls
        captionsEnabled: captionsEnabled,
        currentCaption: currentCaption,
        captionHistory: captionHistory,
        supportsCaptions: supportsCaptions,
        availableCaptionLanguages: availableCaptionLanguages,
        enableCaptions: enableCaptions,
        disableCaptions: disableCaptions,
        toggleCaptions: toggleCaptions,
    };
}
